import { render, staticRenderFns } from "./events-max-age-input.vue?vue&type=template&id=1db77b8a&"
import script from "./events-max-age-input.vue?vue&type=script&lang=js&"
export * from "./events-max-age-input.vue?vue&type=script&lang=js&"
import style0 from "./events-max-age-input.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports